import React from "react";
import { View, ActivityIndicator } from "react-native";
import { useFocusEffect } from "expo-router";
import { StyleSheet } from "@/utils/appStyleSheet";
import { Colors } from "@/constants/Colors";
import useFinanceDataStore from "@/store/financeData";
import SpendingSummaryCard from "@/components/myMoney/SpendingSummaryCard";
import SpendingCategoriesCard from "@/components/myMoney/SpendingCategoriesCard";
import SpendingSubscriptionsCard from "@/components/myMoney/SpendingSubscriptionsCard";
import useWindow from "@/hooks/useWindow";
import FBTrackingService from "@/services/fbTrackingService";

export default function SpendingScreen() {
  const { financeData, isLoading } = useFinanceDataStore();
  const { isDesktop } = useWindow();

  useFocusEffect(
    React.useCallback(() => {
      FBTrackingService.trackViewContent("my-money-spending");
    }, [])
  );

  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color={Colors.primary} />
      </View>
    );
  }

  return (
    <View style={[styles.content, isDesktop && { flexDirection: "row" }]}>
      <View style={[styles.gap, isDesktop && { flex: 1 }]}>
        <SpendingSummaryCard financeData={financeData} />
        <SpendingCategoriesCard financeData={financeData} />
      </View>
      <View style={{ flex: 1 }}>
        <SpendingSubscriptionsCard financeData={financeData} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    paddingTop: 16,
    paddingBottom: 100,
    gap: 16,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.background,
  },
  gap: {
    gap: 16,
  },
});
